import { render, staticRenderFns } from "./addTransferRegion.vue?vue&type=template&id=3d3f6bba&scoped=true&"
import script from "./addTransferRegion.vue?vue&type=script&lang=ts&"
export * from "./addTransferRegion.vue?vue&type=script&lang=ts&"
import style0 from "./addTransferRegion.vue?vue&type=style&index=0&id=3d3f6bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3f6bba",
  null
  
)

export default component.exports